interface ButtonLoadingLabelProps {
  label: string;
}

const ButtonLoadingLabel = ({ label }: ButtonLoadingLabelProps) => (
  <span className="inline-flex items-center justify-center gap-2">
    <span
      aria-hidden="true"
      className="inline-block h-4 w-4 shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"
    />
    <span>{label}</span>
  </span>
);

export default ButtonLoadingLabel;
